import { useTranslation } from '@thoughtspot/i18n';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Select } from '@thoughtspot/radiant-react/widgets/select';
import React, { useCallback, useEffect, useState } from 'react';
import { checkURL, getStatusCodeAndMessageFromPrismError, isSetIntegrationDisabeld, transformToIntegrationData, TranslationsKeys, } from '../util';
import styles from './add-edit-integration.module.scss';
const AddEditIntegration = ({ onSave, onCancel, vendorsList, isModalOpen, currRow, vendorsListLoading, setIntegrationLoading, setIntegrationError, vendorsListError, }) => {
    const { t } = useTranslation();
    const [data, setData] = useState(transformToIntegrationData(currRow));
    const isEdit = currRow !== null;
    const [isNotURL, setIsNotURL] = useState(false);
    const [bannerMessage, setBannerMessage] = useState('');
    const handleSave = useCallback(() => {
        onSave(data);
    }, [onSave, data]);
    const [invalidCredentials, setInvalidCredentials] = useState(false);
    const handleVendorSelect = useCallback((selectedVendor) => {
        setData({
            ...data,
            vendor: selectedVendor.id,
            vendorName: selectedVendor.label,
            name: selectedVendor.label,
        });
    }, [data]);
    const handleEndpointUrlChange = useCallback((_event, value) => {
        setIsNotURL(!checkURL(value));
        setData({ ...data, endpointUrl: value });
        setInvalidCredentials(false);
    }, [data]);
    const handleApiKeyChange = useCallback((_event, value) => {
        setData({ ...data, apiKey: value });
        setInvalidCredentials(false);
    }, [data]);
    useEffect(() => {
        setData(transformToIntegrationData(currRow));
    }, [currRow]);
    useEffect(() => {
        setInvalidCredentials(false);
        if (setIntegrationError) {
            const backendError = getStatusCodeAndMessageFromPrismError(setIntegrationError);
            let failureMessage;
            if (backendError) {
                if (backendError.statusCode)
                    setInvalidCredentials(true);
                failureMessage = backendError.message;
            }
            else if (isEdit)
                failureMessage = t(TranslationsKeys.FAILED_MSG_EDIT_INTEGRATION);
            else
                failureMessage = t(TranslationsKeys.FAILED_MSG_ADD_INTEGRATION);
            setBannerMessage(failureMessage);
        }
    }, [setIntegrationError]);
    const onCloseBanner = useCallback(() => {
        setBannerMessage('');
        setInvalidCredentials(false);
    }, []);
    return (React.createElement(Modal, { size: ModalSize.SMALL, title: isEdit
            ? t(TranslationsKeys.MODAL_TITLE_EDIT_INTEGRATION)
            : t(TranslationsKeys.MODAL_TITLE_ADD_INTEGRATION), isOpen: isModalOpen, confirmButton: {
            text: isEdit
                ? t(TranslationsKeys.UPDATE_INTEGRATION_BTN)
                : t(TranslationsKeys.ADD_BTN),
            onConfirm: handleSave,
            isDisabled: isSetIntegrationDisabeld(data) || isNotURL,
            isLoading: setIntegrationLoading,
        }, dismissButton: {
            text: t(TranslationsKeys.CANCEL),
        }, onDismiss: onCancel },
        React.createElement(Vertical, { hAlignContent: "stretch", grow: true, className: styles.content, spacing: "f", "data-testid": isEdit ? 'edit-integration-body' : 'add-integration-body' },
            React.createElement(Alert.Banner, { message: bannerMessage, isVisible: !!bannerMessage, onClose: onCloseBanner, type: BannerAlertType.ERROR, "data-testid": "integration-alert-banner" }),
            React.createElement(FormControl, { label: t(TranslationsKeys.SELECT_VENDOR), labelClassname: styles.formControlLabel, hasError: vendorsListError !== undefined, errorMessage: t(TranslationsKeys.ERROR_VENDORS_LIST), noMarginBottom: true, disabled: isEdit },
                React.createElement(Select.Dropdown, { id: "selectVendor", selectedOptions: [data?.vendor], optionsGroups: vendorsList, placeholder: t(TranslationsKeys.SELECT_VENDOR), onChange: handleVendorSelect, loading: vendorsListLoading, emptyText: t(TranslationsKeys.NO_VENDORS_TO_ADD), disabled: isEdit, "data-testid": "vendorsList-dropDown" })),
            data?.vendor && (React.createElement(Vertical, { spacing: "f" },
                React.createElement(FormControl, { label: t(TranslationsKeys.END_POINT_URL), labelClassname: styles.formControlLabel, hasError: invalidCredentials || isNotURL, errorMessage: isNotURL ? t(TranslationsKeys.INVALID_URL) : '', noMarginBottom: true },
                    React.createElement(Input.Text, { placeholder: t(TranslationsKeys.ENTER_URL), value: data.endpointUrl, onChange: handleEndpointUrlChange, "data-testid": "integration-endPointURL" })),
                React.createElement(FormControl, { label: t(TranslationsKeys.API_KEY), labelClassname: styles.formControlLabel, hasError: invalidCredentials, noMarginBottom: true },
                    React.createElement(Input.Text, { placeholder: t(TranslationsKeys.ENTER_API_KEY), value: data.apiKey, onChange: handleApiKeyChange, hasError: invalidCredentials, "data-testid": "integration-api" })))))));
};
export default AddEditIntegration;
//# sourceMappingURL=add-edit-integration.js.map